import React, { useEffect, useState } from 'react';
import { Box, FormControl, FormLabel, RadioGroup, Radio } from '@mui/material';
import { RadioOption } from '.';

interface IYesNoComponentProps {
  header: string;
  yesComponent?: React.ReactNode;
  noComponent?: React.ReactNode;
  onChange?: (value: YesNo, name?: string) => void;
  value: YesNo;
  name?: string;
  readOnly?: boolean;
  hideNotEvaluated?: boolean;
}

export function YesNoComponent(props: IYesNoComponentProps) {
  const { header, yesComponent, noComponent, onChange, value, name, readOnly, hideNotEvaluated } = props;

  const [isActive, setIsActive] = useState<YesNo>(value);

  function handleActiveChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newValue = (event.target as HTMLInputElement).value as YesNo;
    setIsActive(newValue);
    onChange && onChange(newValue, name);
  }

  useEffect(() => {
    setIsActive(value);
  }, [value]);

  return (
    <Box>
      <FormControl component="fieldset" sx={{ paddingLeft: 1.7 }}>
        <FormLabel id="active-radios" component="legend">
          {header}
        </FormLabel>
        {readOnly ? (
          <Box>{getYesNoDisplay(isActive)}</Box>
        ) : (
          <RadioGroup aria-labelledby="active-radios" row name="active" value={isActive} onChange={handleActiveChange}>
            <RadioOption value={YesNo.Yes} control={<Radio />} label="Ja" />
            <RadioOption value={YesNo.No} control={<Radio />} label="Nej" />
            {!hideNotEvaluated && <RadioOption value={YesNo.None} control={<Radio />} label="Ikke vurderet" />}
          </RadioGroup>
        )}
      </FormControl>
      {yesComponent && isActive === YesNo.Yes && <Box mt={1}>{yesComponent}</Box>}
      {noComponent && isActive === YesNo.No && <Box mt={1}>{noComponent}</Box>}
    </Box>
  );
}

export enum YesNo {
  Yes = 'yes',
  No = 'no',
  None = 'none',
}

function getYesNoDisplay(value: YesNo) {
  switch (value) {
    case YesNo.Yes:
      return 'Ja';
    case YesNo.No:
      return 'Nej';
    case YesNo.None:
      return 'Ikke vurderet';
    default:
      return 'Ikke vurderet';
  }
}
